import React, { useState } from "react";
import { Modal, Spinner, Text } from "@shopify/polaris";
import { CircularProgressbar, buildStyles } from "react-circular-progressbar";
import "react-circular-progressbar/dist/styles.css";
const ProgressBar = (props) => {
  console.log("props.progress=", props.progress);
  return (
    <div className="loadingScreen">
      <div className="loadingSpinner">
        <CircularProgressbar
          styles={buildStyles({
            textColor: "white",
            pathColor: `#989898`,
            trailColor: "white",
          })}
          value={props.progress}
          text={`${props.progress}%`}
          strokeWidth={5}
        />
        {/* <p style={{ color: "white" }}>{props.progress}</p>
        <Spinner /> */}
      </div>
    </div>
  );
};

export default ProgressBar;
